// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"9b15ea79","226":"3412fc02","305":"1b51ca5d","572":"434a23d1","935":"d4f92c75"}[chunkId] + ".chunk.js";
};